"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isForeverFreeCoupon = void 0;
var isForeverFreeCoupon = function isForeverFreeCoupon(coupon) {
  return (coupon === null || coupon === void 0 ? void 0 : coupon.duration) === 'forever' && (coupon === null || coupon === void 0 ? void 0 : coupon.percentOff) === 100;
};
exports.isForeverFreeCoupon = isForeverFreeCoupon;